<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            ajax-path="sip/cdr"
            @rowSelected="handleRowSelected"
        />
        <app-modal
            :show.sync="showDetailsModal"
            width="lg:w-1/2"
        >
            <template slot="header">Details</template>
            <template slot="body">
                <div style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                    <div>
                        <div class="mb-2 font-bold">Source Username</div>
                        <div>{{ selected.src_username }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Source Domain</div>
                        <div>{{ selected.src_domain }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Destination Username</div>
                        <div class="break-all">{{ selected.dst_username }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Destination Domain</div>
                        <div>{{ selected.dst_domain }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Call Start Time</div>
                        <div>{{ selected.call_start_time }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Call End Time</div>
                        <div>{{ selected.call_end_time }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Duration</div>
                        <div>{{ selected.duration }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">SIP Call ID</div>
                        <div class="break-all">{{ selected.sip_call_id }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">SIP To Tag</div>
                        <div>{{ selected.sip_to_tag }}</div>
                    </div>
                    <div>
                        <div class="mb-2 font-bold">Source IP</div>
                        <div>{{ selected.src_ip }}</div>
                    </div>
                </div>                
            </template>
        </app-modal>        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    import debounce from 'lodash/debounce';
    
    export default {
        data() {
            return {                
                tableIsLoading: false,
                showDetailsModal: false,
                columns: [
                    {
                        title: 'Source Username',
                        field: 'src_username',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Source Domain',
                        field: 'src_domain',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Destination Username',
                        field: 'dst_username',
                        sorter: 'string',
                        minWidth: 230,
                    },
                    {
                        title: 'Destination Domain',
                        field: 'dst_domain',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Duration',
                        field: 'duration',
                        sorter: 'string',
                        minWidth: 100,
                    },                  
                ],
                actions: []
            }
        },
        computed: {
            ...mapGetters({
                items: 'sip/cdr/items',
                selected: 'sip/cdr/selected',          
            }),
        },
        watch: {
            $route() {
                this.getCallDetails();
            }
        },
        mounted() {
            this.getCallDetails();
        },
        methods: {
            getCallDetails() {
                this.tableIsLoading = true;
                this.$store.dispatch('sip/cdr/index')
                    .then(({ data }) => {                        
                        this.tableIsLoading = false;
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    });
            },
            handleRowSelected(row) {
                this.$store.commit('sip/cdr/setSelected', row.data);
                this.showDetailsModal = true;
            },             
        }
    }
</script>